// Sync data-variant-sold-out on <product-form> when the inner submit button
// gets disabled/enabled by Dawn's variant change handler.
document.querySelectorAll('product-form').forEach((form) => {
  const submit = form.querySelector('.product-form__submit');
  if (!submit) return;

  const update = () => {
    form.dataset.variantSoldOut = submit.disabled ? 'true' : 'false';
  };

  // Initial sync
  update();

  // Watch the disabled attribute of the submit button
  new MutationObserver(update).observe(submit, {
    attributes: true,
    attributeFilter: ['disabled'],
  });
});